import React from 'react';
import { connect } from 'react-redux';
import {
  Thumbnail,
} from 'react-bootstrap';

class TokenThumbnail extends React.Component {

  getThumbnailSrc = () => {
    if (this.props.ipfsPath && this.props.ipfsUrl) {
      return `${this.props.ipfsUrl}/${this.props.ipfsPath.split('://ipfs/').join('/')}`;
    } else {
      return '';
    }
  }

  render() {
    return (
      <Thumbnail className={this.props.className} src={this.getThumbnailSrc()} alt="Player Token">
        {this.props.children}
      </Thumbnail>
    );
  }

}

const mapStateToProps = (state, ownProps) => {
  return {
    ipfsUrl: state.web3.ipfsUrl,
  };
};

export default connect(mapStateToProps)(TokenThumbnail);



// WEBPACK FOOTER //
// ./src/components/TokenThumbnail.js